export var addLazyLoadingToImages = function (html) {
    return html.replace(/<img((?:(?!\sloading\s*=)[^>])*)>/g, '<img loading="lazy"$1>');
};
//# sourceMappingURL=image.js.map